module.exports = __webpack_public_path__ + "assets/0387a3d9523400c101bf56b5b4158cf9.png";